export const changeQuantityReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_QUANTITY":
        return action.payload.quantity;
      default:
        return state;
    }
  };
  